// extracted by mini-css-extract-plugin
export default {"googleSvg":"SignUp_googleSvg__C-Pbn","container":"SignUp_container__G-6LD","container2":"SignUp_container2__9uqGV","input":"SignUp_input__iVLim"};